import { Container } from 'reactstrap';
import SectionHeader from '../../components/SectionHeader';
import TwoLayoutSection from '../../components/TwoLayoutSection';
import SEO from '../../components/SEO';
import InnerBanner from '../../components/InnerBanner';
import { corporateSectionData } from '../../constants/corporateDatas';

const Corporate = () => {
  return (
    <>
      <SEO title="Corporates" />
      <div className="resource">
        {/* <BannerMask /> */}

        <InnerBanner
          title="Corporates"
          description="We offer strategic legal guidance and comprehensive compliance solutions designed to empower your business across customs, GST, cybersecurity, and industry-specific regulations, fostering growth and mitigating risks to ensure seamless global operations and innovation."
        />

        <section className="section-gap-lg">
          <Container>
            <SectionHeader title="Corporate Law" />
            <TwoLayoutSection data={corporateSectionData} />
          </Container>
        </section>
      </div>
    </>
  );
};

export default Corporate;
